export default "__VITE_ASSET__ea88fb57__"